import { FormikErrors } from "formik";
import CryptoJS from "crypto-js";

export const renderError = (
  error: string | string[] | FormikErrors<any> | FormikErrors<any>[]
) => {
  if (typeof error === "string") {
    return error;
  }
  return null;
};

export const renderImagePreview = (imageFile: any, imageUrl: any) => {
  if (imageFile) {
    return URL.createObjectURL(imageFile);
  } else if (imageUrl) {
    return imageUrl;
  } else {
    // console.log("null", null);
    return null;
  }
};

export const convertUTCtoIST = (dateTime: Date) => {
  const utcDateFromDatabase = dateTime;
  const date = new Date(utcDateFromDatabase);
  const ISTOffset = 5.5 * 60 * 60 * 1000;
  const ISTDate = new Date(date.getTime() + ISTOffset);
  return ISTDate.toISOString().slice(0, 16);
};

export const extractVideoId = (url: string) => {
  const regExp =
    /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
  const match = url.match(regExp);
  return match ? match[1] : null;
};

//Function to convert Time from UTC to IST
export function convertToDDMMYYYYWithTime(isoDate: string) {
  const date = new Date(isoDate);

  // IST is UTC + 5:30
  const ISTOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds

  // Calculate the IST date by adding the IST offset to the UTC date
  const istDate = new Date(date.getTime() + ISTOffset);

  // Format the IST date to 'YYYY-MM-DD HH:mm:ss'
  const year = istDate.getFullYear();
  const month = String(istDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed in JavaScript
  const day = String(istDate.getDate()).padStart(2, "0");
  const hours = String(istDate.getHours()).padStart(2, "0");
  const minutes = String(istDate.getMinutes()).padStart(2, "0");
  const seconds = String(istDate.getSeconds()).padStart(2, "0");

  // Combine parts into the final formatted string
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export const stripHtmlTags = (html: any) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

export function formatDateToCustomFormat(date: any) {
  // Ensure date is a Date object
  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  // Extract date components
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  // Construct the formatted date string
  const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;

  return formattedDate;
}

export function encryptData(text: string): string {
  return CryptoJS.AES.encrypt(text, "NCFE@1208").toString();
}
